module.exports = __webpack_public_path__ + "Proxima Nova Regular.a0bae8a7cacb322d0b48.woff";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/ucla-prrla/ucla-prrla/ucla-prrla/fonts/Proxima Nova Regular.woff
// module id = ../../../../../fonts/Proxima Nova Regular.woff
// module chunks = 2